import CardCtaImage from 'components/atomic/molecules/card-cta-image'
import { I18n, useTranslation } from 'components/hooks/use-translation'

const Certificate = () => {
    const { t }: I18n = useTranslation()

    const handleClick = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        })
    }

    return (
        <CardCtaImage
            title={t('path:certificateSection.title')}
            description={t('path:certificateSection.description')}
            buttonText={t('path:certificateSection.buttonText')}
            image="/assets/cert.png"
            onClick={handleClick}
        />
    )
}

export default Certificate
